import React, { useState } from 'react';

import { redirectTo } from '#/lib/redirect';
import { useSelector } from '#/reduxState/storeCore';

import QrSyncModalDesktop from './QrSyncModalDesktop';

export function useQRSync() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const [open, setOpen] = useState(false);

  return {
    qrSyncPlaceholder: open ? (
      <QrSyncModalDesktop
        doNotShowAgainOption={false}
        onClose={() => setOpen(false)}
      />
    ) : null,
    showQrSyncModal: () =>
      walletAddress ? setOpen(true) : redirectTo('/katana-connect'),
  };
}
